@if (cards()) {
  <div
    class="carousel relative m-auto w-full"
    [class.pt-10]="!hideArrows()"
    data-ride="carousel"
  >
    <div
      class="carousel-inner relative grid w-full items-stretch gap-x-3 overflow-visible pb-6"
      [style.grid-template-columns]="gridTemplateColumns()"
    >
      @for (slot of displaySlots(); track $index) {
        @if (slot !== null) {
          <ng-container
            *ngTemplateOutlet="carouselItem(); context: { $implicit: slot }"
          ></ng-container>
        } @else {
          <div
            class="min-w-0"
            aria-hidden="true"
          ></div>
        }
      }
    </div>
    @if (!hideArrows()) {
      <div class="absolute right-0 top-0">
        <app-rounded-icon-button
          [size]="'xs'"
          [disabled]="!currentIndex()"
          [type]="'light'"
          [icon]="'icon-arrow-left'"
          (click)="prev()"
        ></app-rounded-icon-button>
        <app-rounded-icon-button
          class="ml-2"
          [disabled]="
            currentIndex() === cards()!.length - nbDisplayCards() ||
            nbDisplayCards() >= cards()!.length
          "
          [size]="'xs'"
          [type]="'light'"
          [icon]="'icon-arrow-right'"
          (click)="next()"
        ></app-rounded-icon-button>
      </div>
    }
  </div>
}
